export default __webpack_public_path__ + "static/media/work.6dbaff2b.mp4";